import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import { ContentProvider, useContent } from "./context/ContentContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

function HomeLegalNote() {
  const { pathname } = useLocation();
  const { company } = useContent();
  if (pathname !== "/") return null;
  return (
    <div className="bg-[#1c1a17] border-t border-[#332f2a]">
      <p className="max-w-[1240px] mx-auto px-5 md:px-8 py-5 font-body text-[10.5px] leading-[1.7] text-[#7d766c] text-center">
        Fletcher &amp; Stone Building Contractors is a trading name of Hickson Construction Consultants Ltd, a company registered in England &amp; Wales. Company No. {company.companyNo}. VAT Registration No. {company.vatNo}. Registered Office: {company.addressLines?.join(", ")}.
      </p>
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#1c1a17]">
        <div className="w-8 h-8 border-2 border-[#94664f] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function PublicSite() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogPost />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
      <HomeLegalNote />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <ScrollToTop />
            <Routes>
              <Route path="/*" element={<ContentProvider><PublicSite /></ContentProvider>} />
            </Routes>
            <Toaster position="top-center" />
          </AuthProvider>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
